import Repository from '../../repositories/RepositoryFactory';
const ccmDiagnosesRepository = Repository.get('ccmDiagnoses');

export default {
	namespaced: true,
	state: {
		ccmDiagnosesByPatientId: [],
		ccmDiagnosesByCCMRecordId: [],
		ccmDiagnosis: null,
	},
	mutations: {
		STORE_CCM_DIAGNOSES_BY_PATIENT_ID (state, payload) {
			state.ccmDiagnosesByPatientId = payload;
		},
		STORE_CCM_DIAGNOSES_BY_CCM_RECORD_ID (state, payload) {
			state.ccmDiagnosesByCCMRecordId = payload;
		},
		STORE_CCM_DIAGNOSIS (state, payload) {
			state.ccmDiagnosis = payload;
		},

		ADD_CCM_DIAGNOSIS (state, payload) {
			state.ccmDiagnosesByPatientId.unshift(payload);
		},

		REMOVE_CCM_DIAGNOSIS (state, id) {
			state.ccmDiagnosesByPatientId = state.ccmDiagnosesByPatientId.filter((diagnosis) => diagnosis.id !== id);
		},
	},
	actions: {
		async getCCMDiagnosesByPatientId ({ commit }, patientId) {
			const response = await ccmDiagnosesRepository.getCCMDiagnosesByPatientId(patientId);
			commit('STORE_CCM_DIAGNOSES_BY_PATIENT_ID', response.data);
		},
		async getCCMDiagnosesByCCMRecordId ({ commit }, ccmRecordId) {
			const response = await ccmDiagnosesRepository.getCCMDiagnosesByCCMRecordId(ccmRecordId);
			commit('STORE_CCM_DIAGNOSES_BY_CCM_RECORD_ID', response.data);
		},
		async getCCMDiagnosis ({ commit }, patientId) {
			const response = await ccmDiagnosesRepository.getCCMDiagnosis(patientId);
			commit('STORE_CCM_DIAGNOSIS', response.data);
		},
		async addCCMDiagnosis ({ commit }, body) {
			const response = await ccmDiagnosesRepository.addCCMDiagnosis(body);
			commit('ADD_CCM_DIAGNOSIS', response.data);
			return response;
		},
		async updateCCMDiagnosis ({ commit }, request) {
			return await ccmDiagnosesRepository.updateCCMDiagnosis(request.id, request.body);
		},
		async deleteCCMDiagnosis ({ commit }, id) {
			commit('REMOVE_CCM_DIAGNOSIS', id);
			return await ccmDiagnosesRepository.deleteCCMDiagnosis(id);
		},
	},
};
